import { Modal } from "@circleco/compass/components/Modal";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";

import { t } from "@/i18n-js/instance";

import { useImagePostModalStore } from "../store";
import { useHandleFileSelection } from "./hooks/useHandleFileSelection";
import { useMultiImageUpload } from "./hooks/useMultiImageUpload";
import { MultiImageDropZone } from "./MultiImageDropZone";

interface UploadImagesComponentProps {
  onClose: (skipDirtyValidation?: boolean) => void;
  onSelection: () => void;
  open: boolean;
}

export const UploadImagesComponent = ({
  open,
  onClose,
  onSelection,
}: UploadImagesComponentProps) => {
  const isMobile = useIsMobile();
  const { selectedFiles, uploadedImages } = useImagePostModalStore();
  const { handleFileSelection } = useHandleFileSelection(onSelection);
  const { isDragActive, ...dropZoneProps } = useMultiImageUpload({
    handleFileSelection,
    selectedFiles,
    uploadedFilesCount: uploadedImages.length,
  });

  return (
    <Modal.Root
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) onClose();
      }}
      size={isMobile ? "full-screen" : "lg"}
    >
      <Modal.Content>
        <Modal.Header
          title={t("image_space.post_modal.steps.create_post.create_title")}
        />
        <Modal.Body customLayout>
          <div className="flex h-[min(32rem,calc(100vh-8rem))] min-h-0 cursor-pointer flex-col rounded-b-lg">
            <MultiImageDropZone
              isDragActive={isDragActive}
              {...dropZoneProps}
            />
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
